class TagFilter extends HTMLSelectElement {
    constructor() {
        super(), this.beforeInit(), this.addEventListener("change", this.onChange)
    }
    beforeInit() {
        const e = this.options[this.selectedIndex].text,
            t = theme.getElementWidth(this, e);
        this.style.setProperty("--width", `${t}px`)
    }
    onChange() {
        window.location.href = this.value
    }
}
customElements.define("tag-filter", TagFilter, {
    extends: "select"
});